export type TagModel = {
	id: string;
	name: string;
};

export const defaults = {
	__typename: 'Tag',
	name: ''
};
